import React, { useEffect, useState } from 'react';
import { 
  Container, 
  Typography, 
  Grid, 
  Paper, 
  Box,
  CircularProgress,
  Alert
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import analyticsService from '../services/analyticsService';
import WeeklyCostChart from '../components/analytics/WeeklyCostChart';
import TopDishesChart from '../components/analytics/TopDishesChart';
import InsightCards from '../components/analytics/InsightCards';
import StatsCards from '../components/analytics/StatsCards';

const AnalyticsPage = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [topDishes, setTopDishes] = useState([]);

  useEffect(() => {
    const loadAnalyticsData = async () => {
      try {
        setLoading(true);
        
        // Fetch analytics data from backend
        const cookedAnalytics = await analyticsService.getCookedDishesAnalytics();
        
        setAnalyticsData(cookedAnalytics.overview);
        setTopDishes(cookedAnalytics.topDishes);
        
      } catch (err) {
        console.error('Error loading analytics data:', err);
        setError('Failed to load analytics data');
        
        // Fallback to empty data structure
        setAnalyticsData({
          totalDishes: 0,
          totalRestaurants: 0,
          totalIngredients: 0,
          totalPlans: 0,
          cookedDishes: 0
        });
        setTopDishes([]);
      } finally {
        setLoading(false);
      }
    };

    loadAnalyticsData();
  }, []);

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  if (!analyticsData) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="info">No analytics data available</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('analytics.title')}
      </Typography>

      <Grid container spacing={3}>
        {/* Insight Cards */}
        <Grid item xs={12}>
          <StatsCards data={analyticsData}/>
          {/* <InsightCards data={analyticsData} topDishes={topDishes} /> */}
        </Grid>

        {/* Weekly Cost Chart */}
        <Grid item xs={12} md={7}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Weekly Grocery Spending
            </Typography>
            <WeeklyCostChart data={analyticsData} topDishes={topDishes} />
          </Paper>
        </Grid>

        {/* Top Dishes Chart */}
        <Grid item xs={12} md={5}>
          <Paper sx={{ p: 3, height: 'fit-content' }}>
            <Typography variant="h6" gutterBottom>
              {t('analytics.topDishes')}
            </Typography>
            <TopDishesChart data={topDishes} />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AnalyticsPage;